import { useContext } from 'react';
import { LouiseOffer } from '../../../../../../../types/Quotes';
import { OfferState } from '../../../../services/offersService';
import { SingleOfferStateContext } from './SingleOfferStateProvider';

interface UseOffer {
  offer: LouiseOffer;
  fetchQuote: () => void;
  isFetching: boolean;
  isLoading: boolean;
  isError: boolean;
  isFetched: boolean;
}

const useOffer = (): UseOffer => {
  const singleOfferState = useContext(SingleOfferStateContext);
  if (!singleOfferState?.offer)
    throw new Error(
      'Offer not defined, please check if you are using this hook inside the SingleOfferStateProvider',
    );

  return {
    offer: singleOfferState.offer,
    fetchQuote: singleOfferState.fetchQuote,
    isFetching: singleOfferState.isFetching,
    isLoading: singleOfferState.offer.state === OfferState.LOADING,
    isError: singleOfferState.offer.state === OfferState.ERROR,
    isFetched: singleOfferState.offer.state === OfferState.FETCHED,
  };
};

export default useOffer;
